import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import StorageKey from './enums/StorageKey';
import PreOrder from './containers/PreOrder/PreOrder';
import Order from './containers/Order/Order';
import CookieBanner from './components/CookieBanner/CookieBanner';
import PublicForm from './containers/PublicForm/PublicForm';
import config from './config';
import styles from './App.module.scss';
import Donation from './containers/Donation/Donation';
import LegacyDonation from './containers/LegacyDonation/LegacyDonation';
import LegacyOrder from './containers/LegacyOrder/LegacyOrder';

window.debugMode = JSON.parse(window.localStorage.getItem(StorageKey.DEBUG_MODE) || 'false');

const App = () => (
	<Router>
		<div className={styles.container}>
			<Switch>
				<Route exact path="/:lng?/payment/:id" render={() => <PublicForm />} />
				<Route exact path="/:lng?/payment/preorder/:id" render={() => <PreOrder />} />
				<Route exact path="/:lng?/payment/order/:id" render={() => <Order />} />
				<Route exact path="/:lng?/payment/donation/:id" render={() => <Donation />} />
				<Route
					exact
					path="/:lng?/integration/buttons/:id-:key.html"
					render={() => <LegacyDonation />}
				/>
				<Route
					exact
					path="/:lng?/order/view/:id-:key.html"
					render={() => <LegacyOrder />}
				/>
			</Switch>
		</div>
		<CookieBanner
			facebookPixelId={config.FACEBOOK_PIXEL_ID}
			gtmId={config.GTM_ID}
			hotjarId={config.HOTJAR_ID}
			includeFBPixel={config.INCLUDE_FB_PIXEL}
			isHotjarTrackingEnabled={config.IS_HOTJAR_TRACKING_ENABLED}
			twitterPixelId={config.TWITTER_PIXEL_ID}
			utmTracking={localStorage.getItem(StorageKey.UTM_UUID) || undefined}
			authDomain={config.AUTH_DOMAIN}
		/>
	</Router>
);

export default App;
